module.exports = __webpack_public_path__ + "static/img/Market.5d84cf4.png";